<template>
  <base-message :message="message">
    <div class="message-body is-block checkpoints-message">
      <div class="message-header">课堂内容导航</div>
      <div class="message-block-content">
        <p class="tip">本堂课讲授以下内容。点击快速前往指定小节，{{ time }} 秒后自动从头开始上课！</p>
        <button
            v-for="checkpoint in message.data.checkpoints"
            class="button is-white"
            @click="next(checkpoint)">
          <v-color-icon :size="24" class="is-text-link" name="arrow-right"></v-color-icon>
          <span>{{ checkpoint.text || '从头开始' }}</span>
        </button>
      </div>
    </div>
  </base-message>
</template>

<script>
import IClassroom from '@/components/classroom/lib/IClassroom'
import BaseMessage from '@/components/classroom/messages/BaseMessage'

export default {
  components: { BaseMessage },
  props: ['message'],
  data () {
    return {
      IClassroom,
      time: 8,
      timer: null
    }
  },
  mounted () {
    if (!this.message.data.checkpoints) {
      return this.next({})
    }
    if (this.message.data.checkpoints.length === 1) {
      return this.next(this.message.data.checkpoints[0])
    }
    this.countdown()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    next (branch) {
      IClassroom.requestNextMessage(0, branch.id)
      IClassroom.removeMessageById(this.message.id)
    },
    countdown () {
      if (this.time > 0) {
        this.time -= 1
        this.timer = setTimeout(this.countdown, 1000)
      } else {
        const cps = this.message.data.checkpoints
        if (cps[cps.length - 1].type === 'Checkpoint') {
          this.next(cps[0])
        } else {
          this.next(cps.pop())
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.checkpoints-message {
  width 100%
}

.tip {
  margin-bottom .5rem
}

.button {
  display flex
}
</style>
